import React, { FC, useState } from 'react'
import { useIntl } from 'react-intl'
import useUser from '../../../hooks/User'
import { useSortable } from '@dnd-kit/sortable'
import { ReportTerminFilter } from '../../../interfaces/ReportTermin'

interface ItemTemplateCompanyReportTerminProps {
    id: string
    dataCompanyTemplate: ReportTerminFilter
    handleUseTemplate: (dataCompanyTemplate: ReportTerminFilter) => void
    setShowModifyTemplateModal: (showModifyTemplateModal: boolean) => void
    setType: (type: string) => void
    setTemplate: (template: ReportTerminFilter) => void
    handleUpdateUserTemplate: (type: string, dataCompanyTemplate: ReportTerminFilter) => void
    setShowDeleteTemplateModal: (showDeleteTemplateModal: boolean) => void
}

const ItemTemplateCompanyReportTermin: FC<ItemTemplateCompanyReportTerminProps> = ({ 
    id, 
    dataCompanyTemplate, 
    handleUseTemplate, 
    setShowModifyTemplateModal, 
    setType, 
    setTemplate, 
    handleUpdateUserTemplate, 
    setShowDeleteTemplateModal 
}) => {
    const user = useUser()
    const intl = useIntl()
    const [isHover, setIsHover] = useState(false)
    const { attributes, listeners, setNodeRef, transform, isDragging } = useSortable({
        id,
        transition: {
            duration: 300,
            easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
        },
    });

    const style = transform
        ? {
            transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
            boxShadow: isDragging ? '0 4px 8px rgba(0, 0, 0, 0.1)' : 'none',
            backgroundColor: dataCompanyTemplate.content.use ? "#009EF7" : "white",
            padding: '5px',
        }
        : {
            padding: '5px',
            backgroundColor: dataCompanyTemplate.content.use ? "#009EF7" : "white",
        };

    const bulletStyle = {
        display: isHover ? 'none' : 'block'
    };

    return (
        <div
            ref={setNodeRef}
            {...attributes}
            {...listeners}
            className={`d-flex cursor-pointer ${!dataCompanyTemplate.content.use && isHover && "bg-hover-light"} p-1 my-1 rounded-2`}
            style={style}
            onMouseEnter={() => setIsHover(true)}
            onMouseLeave={() => setIsHover(false)}
        >
            {isHover && (
                <div className="mx-1 cursor-move">
                    <i className={`fas fa-grip-vertical ${dataCompanyTemplate.content.use && "text-light"}`}></i>
                </div>
            )}

            {
                dataCompanyTemplate.content.use ?
                    <div className="align-items-center w-100 ps-2" style={{ display: "inherit" }}>
                        <div className="bullet w-8px h-6px rounded-2 me-2" style={{ ...bulletStyle, backgroundColor: "#E4E6EF" }}></div>
                        <span className={`text-light fs-6`}>{dataCompanyTemplate.name}</span>
                    </div>
                    :
                    <div className="align-items-center w-100 ps-2" style={{ display: "inherit" }} onClick={() => { handleUseTemplate(dataCompanyTemplate) }}>
                        <div className="bullet w-8px h-6px rounded-2 me-2" style={{ ...bulletStyle, backgroundColor: "#E4E6EF" }}></div>
                        <span className={`text-gray-800 fs-6`}>{dataCompanyTemplate.name}</span>
                    </div>
            }

            {
                user.data.is_superadmin &&
                <div className="d-flex align-items-center">
                    <div className="d-flex flex-center">
                        <div className="dropup-center dropup">
                            <span className="badge px-3" data-bs-toggle="dropdown" aria-expanded="false">
                                <i className={`fas fs-8 fa-ellipsis-v ${dataCompanyTemplate.content.use && "text-light"}`}></i>
                            </span>
                            <ul className="dropdown-menu">
                                <li>
                                    <div
                                        className="dropdown-item pointer-cursor"
                                        onClick={() => {
                                            setShowModifyTemplateModal(true)
                                            setType("update-template-company")
                                            setTemplate(dataCompanyTemplate)
                                        }}
                                    >
                                        {intl.formatMessage({ id: "FORM.ACTION.UPDATE" })} {intl.formatMessage({ id: "FORM.LABEL.NAME" })}
                                    </div>
                                </li>
                                {
                                    dataCompanyTemplate.content.use &&
                                    <li>
                                        <div
                                            className="dropdown-item pointer-cursor"
                                            onClick={() => {
                                                handleUpdateUserTemplate("update-template-company", dataCompanyTemplate)
                                            }}
                                        >
                                            {intl.formatMessage({ id: "FORM.ACTION.SAVE" })}
                                        </div>
                                    </li>
                                }
                                <li onClick={() => { setShowDeleteTemplateModal(true); setTemplate(dataCompanyTemplate); setType("delete-template-company") }}>
                                    <div className="dropdown-item pointer-cursor">{intl.formatMessage({ id: "FORM.ACTION.DELETE" })}</div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default ItemTemplateCompanyReportTermin 